/* eslint-disable consistent-return */

/* eslint-disable no-console */
import isNil from "lodash.isnil";
import { set as setCookie, get as getCookie } from "es-cookie";
import { getGlobal } from "./global";

const checkEnabled = () => {
  return getGlobal("__ANALYTICS_ENABLE__");
};

const _getAmplitudeFromGlobal = () => {
  const amplitude = getGlobal("amplitude");

  if (process.env.NODE_ENV === "development") {
    return {
      getInstance() {
        return {
          setUserId(...args) {
            console.log("AMPLITUDE.setUserId() with", args);
          },

          setUserProperties(...args) {
            console.log("AMPLITUDE.setUserProperties() with", args);
          },

          logEvent(...args) {
            console.log("AMPLITUDE.logEvent() with", args);
          }

        };
      }

    };
  }

  if (typeof amplitude !== "object") {
    throw new Error("Amplitude library is not load");
  }

  return amplitude;
};
/**
 * Setting Multiple User Properties
 * @param {*} userProperties -User properties are attributes of the users and reflect the current state of the user
 * @param {*} name - name cookies are used to cancel re-sending an event
 */


const setUserProperties = (userProperties, name = false) => {
  if (!checkEnabled()) {
    return false;
  }

  if (name && typeof name === "string") {
    const cookieName = `_selfpub_amplitude_${name}`;
    const serializeUserProperties = JSON.stringify(userProperties);

    if (getCookie(cookieName) === serializeUserProperties) {
      return false;
    }

    setCookie(cookieName, serializeUserProperties, {
      expires: 30
    }); // maximum age of cookies 30 days
  }

  const amplitude = _getAmplitudeFromGlobal();

  if (!amplitude) {
    return false;
  }

  if (!isNil(userProperties) && typeof userProperties === "object") {
    amplitude.getInstance().setUserProperties(userProperties);
  }
};

const logEvent = (eventName, eventProperties, userProperties) => {
  if (!checkEnabled()) {
    return false;
  }

  const amplitude = _getAmplitudeFromGlobal();

  if (!amplitude) {
    return false;
  }

  setUserProperties(userProperties);
  amplitude.getInstance().logEvent(eventName, eventProperties);
};

const setUserId = userId => {
  if (!checkEnabled()) {
    return false;
  }

  const amplitude = _getAmplitudeFromGlobal();

  if (!amplitude) {
    return false;
  }

  amplitude.getInstance().setUserId(userId);
};

export { setUserId, setUserProperties, logEvent };